import MasterDetailsContextExample from "./examples/Context.Example";
import SingleLayerMasterPanelExample from "./examples/SingleLayer.Example";
import personaFemaleImage from "./examples/persona-female.png";
import personaMaleImage from "./examples/persona-male.png";

export default [
    {
        title: "Using Context",
        component: MasterDetailsContextExample,
        code: require("!raw-loader!./examples/Context.Example"),
        dependencies: {
            "MasterDetail.Example.css": require("!raw-loader!./examples/MasterDetail.Example.css"),
            "persona-female.png": personaFemaleImage,
            "persona-male.png": personaMaleImage
        },
        stretchContainer: true
    },
    {
        title: "SingleLayer",
        component: SingleLayerMasterPanelExample,
        code: require("!raw-loader!./examples/SingleLayer.Example"),
        stretchContainer: true
    }
];
